import moment from "moment";
import { convertPrometheusTimeToSeconds } from "utils/functions";
import { useDateTimeFormatStore } from "hooks/useDateTimeFormatStore";

export const CustomRangeDetails = ({ lastTimeRangeSelect }: any) => {
    const dateTimeFormat = useDateTimeFormatStore((state) => state.dateTimeFormat);
    return (
        <div className="custom-range-info">
            {moment(lastTimeRangeSelect.query_time, "X")
                .subtract(
                    convertPrometheusTimeToSeconds(
                        lastTimeRangeSelect.time_range
                    ),
                    "second"
                )
                .format(dateTimeFormat)}{" "}
            <br />-{" "}
            {moment(lastTimeRangeSelect.query_time, "X").format(dateTimeFormat)}
        </div>
    );
};
